import api from './interceptor';

const BASE_URL_V2 = 'api/v2/emr';

export default {
  // API Version 2
  getEpicInfo: params => api.get(`${BASE_URL_V2}/epic/videocall/parameters`, { params }),
  setEpicStatus: params => api.get(`${BASE_URL_V2}/epic/videocall/status`, params),
};
